import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

const ReplyComment = (props: any) => {
  const { onClose, isOpenModal, onSubmitReply, currentComment } = props;
  const [reply, setReply] = useState(null as any);

  const handleOnSubmit = async (event: any) => {
    if (onSubmitReply) {
      onSubmitReply(reply);
    }
    event.preventDefault();
    onClose();
  };

  const changeComment = (e: any) => {
    setReply(e.target.value);
  };

  const getReply = () => {
    return currentComment.Reply ? currentComment.Reply.Reply : "";
  };

  return (
    <Modal show={isOpenModal} onHide={onClose} centered size={"lg"} className="add-folder-modal">
      <Modal.Header closeButton>
        <Modal.Title>Phản hồi</Modal.Title>
      </Modal.Header>
      <Form noValidate onSubmit={handleOnSubmit}>
        <Modal.Body className="py-3 px-5">
          <div>
            <textarea
              autoFocus={true}
              rows={5}
              onChange={changeComment}
              defaultValue={getReply()}
              className="py-2 w-100 md-4"
              style={{ paddingInline: "10px" }}
            />
            <br />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" variant="info">
            Gửi phản hồi
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
export default ReplyComment;
